export default "__VITE_ASSET__C9eRh9GB__"